import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '@maximizer/core/shared/data-access';
import { NullableDateValue } from '@maximizer/core/shared/domain';
@Pipe({
    name: 'dateFormat',
    pure: false,
})
export class DateFormatPipe implements PipeTransform {
  constructor(private readonly locale: LocaleService) {}

  transform(date: NullableDateValue, dateFormat: string): string {
    return this.locale.formatDate(date, dateFormat);
  }
}
